// Types references for VSCode Intellisense
/// <reference path="../../../../../node_modules/@types/jquery/index.d.ts"/>
/// <reference path="../../../../../node_modules/@types/underscore/index.d.ts"/>
/**
 * @typedef {import("./types").Item} Item Data for single item to display in the merchandising zone
 * @typedef {import("./types").ItemImage} ItemImage Container for image url and alt text
 * @typedef {import("./types").Settings} Settings Sidepanel settings
 */
define('CXExtensibility.CoreContent.CMSMerchzoneCCT.View', [
    'CustomContentType.Base.View',
    'cxextensibility_corecontent_cmsmerchzonecct.tpl',
    'Utils',
    'jQuery',
    'underscore',
], /**
 * @param {JQueryStatic} $
 * @param {_.UnderscoreStatic} _
 */ function (CustomContentTypeBaseView, template, Utils, $, _) {
    'use strict';
    var displayModes = {
        HORIZONTAL: '1',
        VERTICAL: '2',
        GRID: '3',
    };
    var isMobile = false;
    return CustomContentTypeBaseView.extend({
        template: template,
        /**@type {Settings}*/
        settings: null,
        initialize: function (options) {
            this._initialize();
            this.on('afterViewRender', function () {
                this.container = options.container;
                var merchRule = this.settings.custrecord_merchzone_merchrule;
                isMobile = window.matchMedia("(max-width: 767px)").matches
                if (merchRule && merchRule !== '') {
                    this.fetchMerchZoneEndpoint(merchRule);
                }
            });
        },
        /**
         * Get items currently on page
         * 
         * @returns {Promise}
         */
        fetchPageItems: function() {
            var deferred = $.Deferred();
            var itemInfo = this.container.getComponent('PDP').getItemInfo();
            
            if (itemInfo == null) {
                deferred.resolve([]);
            } else {
                deferred.resolve([itemInfo.item.internalid]);
            }
            
            return deferred.promise();
        },
        /**
         * Get items currently in user's cart
         * 
         * @returns {Promise}
         */
        fetchCartItems: function() {
            var deferred = $.Deferred();
            var itemIds = [];
            var self = this;
            this.container.getComponent('Cart').getLines().done(function(lines) {
                _.each(
                    lines,
                    function(line) {
                        itemIds.push(line.item.internalid);
                    }
                )
                deferred.resolve(itemIds);
            });
            return deferred.promise();
        },
        /**
         * Fetch merchzone information from SMT CMS endpoint
         * @param {string | number} merchzoneId Merchzone ID to fetch
         */
        fetchMerchZoneEndpoint: function fetchMerchZoneEndpoint(merchzoneId) {
            $.ajax({
                url: '/api/cms/v2/merchzones/' + merchzoneId,
            }).done(
                function (res) {
                    var isExcludeCartItem = res.data[0].cartItem;
                    var isExcludeCurrentItem = res.data[0].currentItem;
                    this.fetchItems(res.data[0].queryString, isExcludeCartItem, isExcludeCurrentItem);
                }.bind(this)
            );
        },
        /**
         * Fetch items from items enddpoint returned from merchzone endpoint
         * @param {string} itemsEndpoint
         */
        fetchItems: function fetchItems(itemsEndpoint, isExcludeCartItem, isExcludeCurrentItem) {
            $.ajax({
                url: itemsEndpoint,
            }).done(
                function (res) {
                    var itemDetails = _.map(
                        res.items,
                        function (item) {
                            /** @type {Item} */
                            var formattedItem = {
                                internalid: item.internalid,
                                matrixchilditems_detail: item.matrixchilditems_detail,
                                name: item.storedisplayname2 || item.displayname,
                                price: item.onlinecustomerprice_formatted,
                                link: '/' + item.urlcomponent,
                                image: this.getDefaultImage(item.itemimages_detail),
                            };
                            return formattedItem;
                        }.bind(this)
                    );
                    this.renderMerchzone(itemDetails, isExcludeCartItem, isExcludeCurrentItem);
                }.bind(this)
            );
        },
        /**
         * Render item info to template, based on items but possibly without item exclusions
         * @param {Item[]} items
         * @param {Boolean} isExcludeCartItem - Flag indicating whether to exclude cart items from the merch zone.
         * @param {Boolean} isExcludeCurrentItem - Flag indicating whether to exclude current page item from the merch zone.
         */
        renderMerchzone: function renderMerchzone(items, isExcludeCartItem, isExcludeCurrentItem) {
            if (items.length === 0) {
                return;
            }
            var heading = this.settings.custrecord_merchzone_heading || '';
            if (heading.length === 0) {
                this.$('.cms-merchzone-heading').remove();
            } else {
                this.$('.cms-merchzone-heading').text(heading);
            }
            var itemPromises = [];
            // Get cart items if not excluded
            if (isExcludeCartItem) {
                itemPromises.push(this.fetchCartItems());
            } else {
                itemPromises.push($.Deferred().resolve([]).promise());
            }
            // Get page items if not excluded
            if(isExcludeCurrentItem) {
                itemPromises.push(this.fetchPageItems());
            } else {
                itemPromises.push($.Deferred().resolve([]).promise());
            }
            var itemTemplate = this.$('#item-template');
            var cmsMerchZoneSlider = this.$('.cms-merchzone-slider');
            var hasChildIncludedInArray = this._hasChildIncludedInArray;
            $.when.apply($, itemPromises).done(function() {
                var args = Array.prototype.slice.call(arguments),
                cartItems = args[0],
                pageItems = args[1];
                var excludeItems = cartItems.concat(pageItems);
                var filteredItems = [];
                for (var i = 0; i < items.length; i++) {
                    if ($.inArray((items[i].internalid * 1), excludeItems) === -1
                            && !hasChildIncludedInArray(items[i], excludeItems)) {
                        filteredItems.push(items[i]);
                    }
                }
                _.each(
                    filteredItems,
                    function (item) {
                        var template = itemTemplate.contents().clone();
    
                        template.find('.item-name').text(item.name);
                        template.find('.item-price').text(item.price);
                        template.find('.item-link').attr('href', item.link);
                        template.find('.item-name').attr('href', item.link);
                        template.find('.cms-merchzone-see-more').attr('href', item.link);
                        template.find('.item-image').attr('src', item.image.url);
                        template.find('.item-image').attr('alt', item.image.altimagetext);
                        cmsMerchZoneSlider.append(template);
                    }
                );
                var sliderRendered = this.$('.cms-merchzone-slider').parent().hasClass('bx-viewport');
                var displayMode = this.settings.custrecord_merchzone_display_mode.toString();
    
                if (displayMode !== displayModes.GRID) {
                    if (sliderRendered) {
                        return;
                    }
    
                    this.renderSlider();
                } else {
                    this.renderGrid();
                }
            }.bind(this)).fail(function(xhr, status, error) {
                console.log(error); // eslint-disable-line no-console
            });
        },
        _hasChildIncludedInArray: function(parentItem, excludeItems) {
            var hasChild = false;
            if (parentItem.matrixchilditems_detail) {
                hasChild = parentItem.matrixchilditems_detail.some(function(childItem) {
                    if ($.inArray((childItem.internalid * 1), excludeItems) !== -1 ) {
                        return true;
                    }
                });
            }
            return hasChild;
        },
        renderSlider: function renderSlider() {
            var displayMode = this.settings.custrecord_merchzone_display_mode || displayModes.HORIZONTAL;
            var mode = displayMode.toString() === displayModes.VERTICAL ? 'vertical' : 'horizontal';
            var numItems = isMobile ? 1 : parseInt(this.settings.custrecord_merchzone_numitems) || 4;
            var merchzoneWidth = this.$('.cms-merchzone-slider').width();
            var slideWidth = Math.floor(merchzoneWidth / numItems);
            var sliderOptions = {
                mode: mode,
                minSlides: numItems,
                maxSlides: numItems,
                slideWidth: slideWidth,
                moveSlides: 1,
                pager: false,
                nextText:
                    '<a class="cms-merchzone-slider-next cms-merchzone-' +
                    mode +
                    '-control"><span class="control-text">' +
                    _('next').translate() +
                    '</span> <i class="carousel-next-arrow"></i></a>',
                prevText:
                    '<a class="cms-merchzone-slider-prev cms-merchzone-' +
                    mode +
                    '-control"><i class="carousel-prev-arrow"></i> <span class="control-text">' +
                    _('prev').translate() +
                    '</span></a>',
            };
            Utils.initBxSlider(this.$('.cms-merchzone-slider'), sliderOptions);
            this.$('.item-image-wrapper').css({ 'min-height': slideWidth + 'px' });
            if (displayMode === displayModes.VERTICAL) {
                this.$('.bx-wrapper').css({ margin: '0 auto' });
            }
            // Fix incorrect height when SCA rerenders the slider
            setTimeout(
                function () {
                    var itemHeight = this.$('.cms-merchzone-item').height();
                    this.$('.bx-viewport').css({ 'min-height': itemHeight });
                }.bind(this)
            );
        },
        renderGrid: function renderGrid() {
            var merchzoneWidth = this.$('.cms-merchzone-slider').width();
            var numItems = isMobile ? 1 : parseInt(this.settings.custrecord_merchzone_numitems) || 3;
            this.$('.cms-merchzone-slider').removeClass('cms-merchzone-slider').addClass('cms-merchzone-grid');
            this.$('.cms-merchzone-grid > li').css({
                width: Math.floor(merchzoneWidth / numItems),
            });
        },
        /**
         * Get the default image or first image found if not available
         * @param {Object} itemimages The object contained in the item's itemimages_detail key
         * @returns {ItemImage}
         */
        getDefaultImage: function getDefaultImage(itemimages) {
            /**
             * Flatten method taken from SCA Utils
             * @param {Object} images
             * @returns {ItemImage[]}
             */
            function flattenImages(images) {
                if ('url' in images && 'altimagetext' in images) {
                    return [images];
                }
                return _.flatten(
                    _.map(images, function (item) {
                        if (_.isArray(item)) {
                            return item;
                        }
                        return flattenImages(item);
                    })
                );
            }
            var imageData = flattenImages(itemimages);
            var defaultImage = _.find(imageData, function (image) {
                var match = image.url.match(/.*\.default\.[A-Za-z]*/i);
                return !!match && match[0] === image.url;
            });
            return defaultImage || imageData[0];
        },
        contextDataRequest: [],
        validateContextDataRequest: function () {
            return true;
        },
        getContext: function () {
            return {
                merchRule: this.settings.custrecord_merchzone_merchrule,
                displayMode: this.settings.custrecord_merchzone_display_mode,
                numItems: this.settings.custrecord_merchzone_numitems,
            };
        },
    });
});
